import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '@evento-ng/libs';

@Component({
  selector: 'app-sport-order-item',
  templateUrl: './sport-order-item.component.html',
  styleUrls: ['./sport-order-item.component.scss'],
})
export class SportOrderItemComponent {
  @Input() order;
  @Input() ticket;
  @Input() hours: any;

  @Output() transferTicketEvent = new EventEmitter<string>();
  @Output() transferDisabledTicketEvent = new EventEmitter<any>();
  @Output() cancelTicketEvent = new EventEmitter<any>();

  constructor(
    public helpers: HelpersService,
    public translate: TranslateService
  ) {}

  transferTicket(ticketId: string) {
    this.transferTicketEvent.emit(ticketId);
  }

  transferDisabledTicket(ticketNumber: string | number) {
    this.transferDisabledTicketEvent.emit(ticketNumber);
  }

  cancelTicket(ids) {
    this.cancelTicketEvent.emit(ids);
  }
}
